import React, { useCallback } from 'react';
import { Flex, Heading, Radio, RadioGroup } from '@chakra-ui/react';
import { replaceHtmlEscapeCharacters } from 'ts/common/utils';

export type ClientPaymentOption = 'full' | 'retainer';

interface Props {
    fullOptionText: string;
    onChange: (x: ClientPaymentOption) => void;
    retainerOptionText: string;
    title: string;
    value: ClientPaymentOption;
}

const ClientPaymentOptions = ({
    fullOptionText,
    onChange,
    retainerOptionText,
    title,
    value
}: Props) => {
    const handleChange = useCallback(
        (nextValue: string) => {
            onChange(nextValue as ClientPaymentOption);
        },
        [onChange]
    );

    return (
        <Flex flexDirection="column" gap="16px">
            <Heading as="h3" size="lg" margin={0}>
                {title}
            </Heading>
            <RadioGroup
                display="flex"
                flexDirection="column"
                gap="12px"
                onChange={handleChange}
                value={value}
            >
                <Radio value="full">{replaceHtmlEscapeCharacters(fullOptionText)}</Radio>
                <Radio value="retainer">{replaceHtmlEscapeCharacters(retainerOptionText)}</Radio>
            </RadioGroup>
        </Flex>
    );
};

export default ClientPaymentOptions;
